import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  en: {
    "取消": 'Cancel',
    "确定": 'Confirm',
    "发送": 'Send',
    "系统通知": 'System notification',
    "关闭": 'Close',
    "图片": 'Image',
    "文件": 'File',
    "表情": 'Emoji',
    "视频": 'Video',
    "录制": 'Record',
    "拍照": 'Take a photo',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
